<template>
  <div>
    <v-card flat
            tile>
      <v-toolbar color="secondary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('details') }}</v-toolbar-title>
      </v-toolbar>
      <category-details ref="categoryDetails"
                       v-bind:category="category" />
    </v-card>
  </div>
</template>

<script>
  import CategoryDetails from '@/components/learning/CategoryDetails'

  export default {
    components: {
      CategoryDetails
    },
    name: 'CategoryDetailsCard',
    methods: {
      validate() {
        return this.$refs.categoryDetails.validate()
      }
    },
    props: {
      category: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "details": "Details"
    },
    "en": {
      "details": "Details"
    }
  }
</i18n>